import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { RequestUserResponse } from "@/types";

async function createUser(request: FormData): Promise<RequestUserResponse> {
  const response = await httpRequest.post<RequestUserResponse>(
    `/users`,
    request,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useCreateUserMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}
